import "./Css/chat.css";
import "./Css/snack.css";

import { OnlineStorage } from "@tblabs/storage";
import { ChatPage } from "./Pages/ChatPage";
import { NewChatPage } from "./Pages/NewChatPage";
import { DestroyingPatternContentSwitcher, Div, HashRef, Root, Switch, TextInput } from "@tblabs/truffle";
import { UserProvider } from "./Services/UserProvider";

TextInput.DefaultCssClasses = "uk-input";

export enum Env
{
    Local = "local",
    Stage = "stage",
    Prod = "prod"
}

export class EnvDetector
{
    public get Env(): Env
    {
        // return Env.Prod;
        if (window.location.origin.includes("localhost"))
            return Env.Local;
        else if (window.location.origin.includes("stage"))
            return Env.Stage;
        else
            return Env.Prod;
    }

    constructor()
    {
        console.log(`Assuming environment is ${this.Env} (window origin: ${window.location.origin})`);
    }
}

(async () =>
{
    const root = new Root("body")
    const hash = new HashRef();

    const _envDetector = new EnvDetector();

    const storageUrl = new Switch<Env, string>(_envDetector.Env)
        .Case(Env.Local, () => 'http://localhost/storageV5/src/')
        .Case(Env.Stage, () => 'https://stage.storage.specteam.pl/v5/')
        .Case(Env.Prod, () => 'https://storage.specteam.pl/v5/')
        .Default(() => 'https://storage.specteam.pl/v5/')
        .Execute() || "";

    const db = "Chat";
    const _storage = new OnlineStorage(storageUrl, db);

    const _user = new UserProvider();

    const pagesSwitcher = new DestroyingPatternContentSwitcher(hash)
    pagesSwitcher
        .AddContent("chat/new", () => new NewChatPage(_storage, _user))
        .AddContent("chat/:id", ({ id }) => new ChatPage(_storage, _user, id))
        .AddDefaultContent(() => new NewChatPage(_storage, _user))
        .Refresh()

    root.Class("main").Append(
        new Div("main__container").Append(
            pagesSwitcher,
        ),
    )
})()
